export default "__VITE_ASSET__B6OS_lf6__"